import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from './Header';
import Topsection from './Topsection';
import Footer from './Footer';
import Frontpopup_form from './Frontpopup_form';
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';

import { Helmet } from 'react-helmet';

const All_Courses = () => {
  const { slug } = useParams(); // Get the dynamic URL part

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        branch: '',
        course: '',
    });

  const allCourses = [
    { category: 'Full-Stack-Development', title: 'Full Stack Java Development', duration: '5 months', logo: "/assets/images/courselogo/java.webp", link: "/course-details/Full-Stack-Java-Development" },
    { category: 'Full-Stack-Development', title: 'Full Stack Python Development', duration: '5 months', logo: "/assets/images/courselogo/python.webp", link: "/course-details/Full-Stack-Python-Development" },
    { category: 'Full-Stack-Development', title: 'Full Stack .Net Development', duration: '5 months', logo: "/assets/images/courselogo/dot_net.webp", link: "/course-details/Full-Stack-Dot-Net-Development" },
    { category: 'MERN-Stack-Development', title: "MERN Stack Development", duration: "5 Months", logo: "/assets/images/courselogo/mern.webp", link: "/course-details/MERN-Stack-Development" },
    { category: 'Software-Testing', title: "Manual Testing", duration: "1 Month", logo: "/assets/images/courselogo/testing.webp", link: "/course-details/Software-Testing" },
    { category: 'Software-Testing', title: "Automation Testing", duration: "4 Months", logo: "/assets/images/courselogo/testing.webp", link: "/course-details/Software-Testing" },
    { category: 'Cloud-Computing', title: "AWS & DevOps", duration: "5 Months", logo: "/assets/images/courselogo/mca.webp", link: "/course-details/Cloud-Computing" },
    { category: 'Data-Science-&-Data-Analytics', title: "Data Science & Data Analytics", duration: "6 Months", logo: "/assets/images/courselogo/datascience.webp", link: "/course-details/Data-Science-And-Data-Analytics" },
    { category: 'Data-Science-&-Data-Analytics', title: "Data Analytics", duration: "4 Months", logo: "/assets/images/courselogo/da.webp", link: "/course-details/Data-Analytics" },
    { category: 'Digital-Marketing', title: "Digital Marketing", duration: "3 Months", logo: "/assets/images/courselogo/digitalmarketing.webp", link: "/course-details/Digital-Marketing" },
    { category: 'Web-Development', title: 'Full Stack Java Development', duration: '5 months', logo: "/assets/images/courselogo/java.webp", link: "/course-details/Full-Stack-Java-Development" },
    { category: 'Web-Development', title: 'Full Stack Python Development', duration: '5 months', logo: "/assets/images/courselogo/python.webp", link: "/course-details/Full-Stack-Python-Development" },
    { category: 'Web-Development', title: 'Full Stack .Net Development', duration: '5 months', logo: "/assets/images/courselogo/dot_net.webp", link: "/course-details/Full-Stack-Dot-Net-Development" },
    { category: 'Web-Development', title: "MERN Stack Development", duration: "5 Months", logo: "/assets/images/courselogo/mern.webp", link: "/course-details/MERN-Stack-Development" },
    { category: 'Android-Development', title: "Android Development", duration: "5 Months", logo: "/assets/images/courselogo/android.webp", link: "/course-details/Android-Development" },
    { category: 'Cyber-Security', title: "Cyber Security", duration: "5 Months", logo: "/assets/images/courselogo/cs.webp", link: "/course-details/Cyber-Security" },
  ];

  const course = allCourses.find(c => c.category === slug);

  // Filter courses based on slug
  const filteredCourses = allCourses.filter(course => course.category === slug);

  useEffect(() => {
    if (course?.title && formData.course !== course.title) {
      setFormData((prev) => ({
        ...prev,
        course: course.title,
      }));
    }
  }, [course, formData.course]);


  //Brochure download
  // const handleDownload = (pdfUrl) => {
  //   const link = document.createElement('a');
  //   link.href = pdfUrl;
  //   link.download = pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  //enquiry form backend
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {

    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required.';
    } else if (!/^[A-Za-z ]+$/.test(formData.name.trim())) {
      newErrors.name = 'Name can contain only letters and spaces.';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters.';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.contact.trim()) {
      newErrors.contact = "Contact is required";
    } else if (formData.contact.trim().length < 10) {
      newErrors.contact = "Contact number must be at least 10 digits";
    }

    if (!formData.branch) newErrors.branch = "Branch selection is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/enquiries`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData }),
      });

      const result = await response.json();

      if (response.ok) {
        alert('Enquiry submitted!');
        // handleDownload(course.pdfUrl);
        setFormData({ name: '', email: '', contact: '', branch: '', course: '' });
      } else {
        alert(result.error || 'Failed to submit enquiry');
      }
    } catch (err) {
      console.error(err);
      alert('Error submitting enquiry');
    }
  };

  return (
    <div>
      <Helmet>
              <title>Fortune Cloud Technologies | {slug.replace(/-/g, ' ')}</title>
              <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
              <meta name="robots" content="index, follow" />
      </Helmet>
      <Topsection />
      <Header />
        <div className='bg-hero1'>
      <div className="container">
        <div className="row">
          <div className="col-md-9">
            <h2 className="mb-3 myfont1 text-black fw-bold pt-2">
              {slug.replace(/-/g, ' ')}
            </h2>

            <div className={`row myfont1 ${filteredCourses.length <= 2 ? 'justify-content-center' : ''}`}>
              {filteredCourses.map((course, index) => (
                <div key={index} className="col-md-4 col-12 mb-4">
                  <div className="border p-3 rounded shadow-sm h-100 bg-white text-center">
                    <img
                      src={course.logo}
                      alt={course.title}
                      className="mb-3"
                      loading="lazy"
                      style={{ maxWidth: '100px' }}
                    />
                    <h5 className='fw-bold text-black'>
                        {course.title === "Data Analytics" ? (
                          <>
                            <br />
                            {course.title}
                          </>
                        ) : (
                          course.title
                        )}
                      </h5>
                    <p className="text-muted">Duration: {course.duration}</p>
                    <Link className="btn btn-outline-info btn-sm" to={course.link}>
                      View Details
                    </Link>
                  </div>
                </div>
              ))}

              {filteredCourses.length === 0 && (
                <div className="col-12 text-center">
                  <p>No courses found for "{slug}"</p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <div className='container mt-4 mb-4 bg-white rounded myfont1'>
                <h3 className='text-white pt-2 pb-2 bg-primary myborderbottom fw-bold'>Enquire Now</h3>
                <form className="p-4" onSubmit={(e) => e.preventDefault()}>
                          <div className="form-group text-start">
                            <input
                              type="text"
                              placeholder="Enter your name"
                              className={`form-control mb-2 rounded-0 ${errors.name ? 'is-invalid' : ''}`}
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="email"
                              placeholder="Enter your email"
                              className={`form-control mb-2 rounded-0 ${errors.email ? 'is-invalid' : ''}`}
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="number"
                              placeholder="Enter your contact"
                              className={`form-control mb-2 rounded-0 ${errors.contact ? 'is-invalid' : ''}`}
                              name="contact"
                              value={formData.contact}
                              onChange={handleChange}
                            />
                            {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
                          </div>

                          <div className="form-group text-start">
                            <select
                              name="branch"
                              className={`form-control mb-4 rounded-0 ${errors.branch ? 'is-invalid' : ''}`}
                              value={formData.branch}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select Branch</option>
                              <option value="Shivajinagar, Pune">Shivajinagar, Pune</option>
                              <option value="Pimpri-Chinchwad, Pune">Pimpri-Chinchwad, Pune</option>
                              <option value="Bengaluru/Bangalore">Bengaluru/Bangalore</option>
                            </select>
                            {errors.branch && <div className="invalid-feedback">{errors.branch}</div>}
                          </div>

                          {/* <input type="hidden" name="course" value={slug.replace(/-/g, ' ')} onChange={handleChange}/> */}
                          
                          <div className="d-grid pb-3 mb-2">
                            <button className="btn btn-primary fw-bold" type="button" onClick={handleSubmit}>Submit</button>
                          </div>
                        </form>
                </div>
          </div>
        </div>
      </div>
      </div>

      <Frontpopup_form />
      <FloatingButton />
      <Mobilefooterbtn />
      <Footer />
    </div>
  );
};

export default All_Courses;
